<button mat-mini-fab class="go-up-fab" color="primary" *ngIf="showGoUpArrow" (click)="goUp()"><mat-icon>keyboard_arrow_up</mat-icon></button>
